import { SoapRanapResponseItem } from "@/types/soap";

export type CocokSoap = (soap: SoapRanapResponseItem) => boolean;

export const cocokSoapPerawat: CocokSoap = soap => soap.stat === "prwt";

export const cocokSoapDokterSaya = (userId: string | number): CocokSoap => soap =>
  soap.stat === "dr" && String(soap.user_id) === String(userId);

function waktuSoap(soap: SoapRanapResponseItem): number {
  return new Date(soap.examined_at).getTime() || 0;
}

export function kandidatSalin(
  semua: SoapRanapResponseItem[],
  registerId: string | number,
  cocok: CocokSoap
): SoapRanapResponseItem[] {
  if (!Array.isArray(semua)) return [];

  return semua
    .filter(
      soap =>
        !!soap &&
        String(soap.register_id) === String(registerId) &&
        cocok(soap)
    )
    .sort(
      (a, b) => waktuSoap(b) - waktuSoap(a) || Number(b.id) - Number(a.id)
    );
}
